import { ErrorMessage } from 'formik';
import React from 'react';
import { Props } from './InputWrapper.types';
import styles from './InputWrapper.module.scss';

const filterByPosition = (position: 'top' | 'bottom') => {
  return (item: NonNullable<Props['extraContent']>[0]) => {
    return item.position === position;
  };
};

const ExtraContentArea = ({ contents, name }: { contents: NonNullable<Props['extraContent']>; name: string }) => {
  return contents.length > 0 ? (
    <div className={styles.extraContent}>
      {contents.map((content, i) => (
        <React.Fragment key={`content-${name}-${i}`}>
          {content.variant === 'component' ? content.content : <p>{content.content}</p>}
        </React.Fragment>
      ))}
    </div>
  ) : (
    <></>
  );
};

const InputWrapper: React.FC<Props> = ({ children, title, name = '', subtitle, extraContent, isRequired = false }) => {
  const [upperContents, bottomContents] = [
    extraContent.filter(filterByPosition('top')),
    extraContent.filter(filterByPosition('bottom')),
  ];

  return (
    <div className={`${styles.wrapper} inputWrapper`}>
      {title && (
        <div className={styles.titleContainer}>
          <label htmlFor={name}>{title}</label>
          {isRequired && <span> *Required</span>}
        </div>
      )}
      {subtitle && <p className="question__subtitle">{subtitle}</p>}
      <ExtraContentArea contents={upperContents} name={`upper-${name}`} />
      <div className={styles.inputWrapper}>{children}</div>
      <ErrorMessage className="error-message coral" component="div" name={name} />
      <ExtraContentArea contents={bottomContents} name={`bottom-${name}`} />
    </div>
  );
};

export default InputWrapper;
